import { isTableType } from 'constants/chart-roles';
import { generatePostProcessedComparator } from 'utils/process-spec-and-data/post-agg-sorting';

/**
 * Add sorting comparators to columns based off information we get from the channels.
 * @param {Object} stageData - object containing documents returned from the agg pipeline, and an environment containing the chart type
 * @returns {Object} - An updated stage with columnDefs with comparators
 */
function encodeColumnSortOrder(stageData) {
  const {
    environment: { chartType, channels },
    spec,
  } = stageData;

  if (!isTableType(chartType)) {
    return {};
  }

  const { columnDefs } = spec;
  const newColumnDefs = columnDefs.map(definition => {
    const field = definition.field;
    return {
      ...definition,
      comparator: generatePostProcessedComparator(channels[field]),
    };
  });

  return { spec: { ...spec, columnDefs: newColumnDefs } };
}

export default {
  input: ['spec', 'environment.chartType', 'environment.channels'],
  fn: encodeColumnSortOrder,
};
export { encodeColumnSortOrder };
